import React from 'react';

const Footer = () => {
  const styles = {
    footer: {
      backgroundColor: '#ffffff',
      fontFamily: 'Arial, sans-serif',
    },
    mapSection: {
      backgroundColor: '#f8f9fa',
      padding: '40px 0',
    },
    mapContainer: {
      maxWidth: '1200px',
      margin: '0 auto',
      padding: '0 20px',
    },
    footerContent: {
      display: 'grid',
      gridTemplateColumns: '1fr 1fr',
      gap: '40px',
      alignItems: 'start',
    },
    companySection: {
      display: 'flex',
      gap: '20px',
    },
    logoContainer: {
      width: '80px',
      height: '80px',
      borderRadius: '8px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexShrink: 0,
      overflow: 'hidden',
    },
    logoImage: {
      width: '100%',
      height: '100%',
      objectFit: 'contain',
    },
    companyInfo: {
      flex: 1,
    },
    companyTitle: {
      fontSize: '18px',
      fontWeight: 'bold',
      color: '#333',
      marginBottom: '10px',
    },
    companyTitleMain: {
      fontSize: '16px',
      fontWeight: 'bold',
      color: '#333',
    },
    companyTitleSub: {
      fontSize: '14px',
      fontWeight: 'normal',
      color: '#666',
    },
    address: {
      fontSize: '14px',
      color: '#666',
      lineHeight: '1.5',
      marginBottom: '10px',
    },
    contactItem: {
      fontSize: '14px',
      color: '#666',
      marginBottom: '5px',
    },
    newsletterSection: {
      textAlign: 'right',
    },
    newsletterTitle: {
      fontSize: '20px',
      fontWeight: 'bold',
      color: '#333',
      marginBottom: '20px',
      textTransform: 'uppercase',
    },
    socialIcons: {
      display: 'flex',
      gap: '10px',
      justifyContent: 'flex-end',
      marginBottom: '20px',
    },
    socialIcon: {
      width: '36px',
      height: '36px',
      backgroundColor: '#e9ecef',
      borderRadius: '4px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      fontSize: '16px',
      color: '#666',
      textDecoration: 'none',
      transition: 'background-color 0.3s ease',
    },
    subscribeButton: {
      backgroundColor: 'transparent',
      border: '2px solid #333',
      borderRadius: '25px',
      padding: '10px 30px',
      fontSize: '14px',
      fontWeight: 'bold',
      color: '#333',
      cursor: 'pointer',
      transition: 'all 0.3s ease',
      textTransform: 'uppercase',
    },
    privacyText: {
      fontSize: '14px',
      color: '#f39c12',
      marginTop: '15px',
      cursor: 'pointer',
      textDecoration: 'none',
      fontWeight: '500',
      display: 'block',
      textAlign: 'center',
    },
    bottomSection: {
      backgroundColor: '#f8f9fa',
      padding: '20px 0',
      borderTop: '1px solid #e9ecef',
    },
    copyright: {
      textAlign: 'center',
      fontSize: '12px',
      color: '#999',
      maxWidth: '1200px',
      margin: '0 auto',
      padding: '0 20px',
    }
  };

  return (
    <>
      <style>{`
        .social-icon:hover {
          background-color: #2d5016 !important;
          color: white !important;
        }
        .subscribe-btn:hover {
          background-color: #333 !important;
          color: white !important;
        }
        @media (max-width: 768px) {
          .footer-content {
            grid-template-columns: 1fr !important;
            gap: 30px !important;
          }
          .newsletter-section {
            text-align: center !important;
          }
          .social-icons {
            justify-content: center !important;
          }
          .company-section {
            flex-direction: column !important;
            align-items: center !important;
            text-align: center !important;
          }
        }
      `}</style>

      <footer style={styles.footer}>
        {/* Company Info Section */}
        <div style={styles.mapSection}>
          <div style={styles.mapContainer}>
            {/* Footer Content */}
            <div style={styles.footerContent} className="footer-content">
              {/* Company Information */}
              <div style={styles.companySection} className="company-section">
                <div style={styles.logoContainer}>
                  <img 
                    src={require('../../../assets/images/siridharinilogo.jpeg')} 
                    alt="SiriDharini Logo" 
                    style={styles.logoImage}
                  />
                </div>
                <div style={styles.companyInfo}>
                  <div style={styles.companyTitleMain}>Siridharini | Corporate Office,</div>
                  <div style={styles.address}>
                    Rashtriya Vidyalaya Road, 2nd Block,<br />
                    Jaya Nagar East, Jayanagar, Bengaluru, Karnataka
                  </div>
                  <div style={styles.contactItem}>+91 9448472706, +91 9036024568</div>
                  <div style={styles.contactItem}>connect@siridharini.com</div>
                </div>
              </div>
              
              {/* Newsletter Section */}
              <div style={styles.newsletterSection} className="newsletter-section">
                <h3 style={styles.newsletterTitle}>Get A Newsletter</h3>
                <div style={styles.socialIcons} className="social-icons">
                  <a href="#" style={styles.socialIcon} className="social-icon">f</a>
                  <a href="#" style={styles.socialIcon} className="social-icon">📷</a>
                  <a href="#" style={styles.socialIcon} className="social-icon">in</a>
                </div>
                <button style={styles.subscribeButton} className="subscribe-btn">
                  Subscribe
                </button>
                <div>
                  <a 
                    href="/documents/PP-SiriDharini.pdf" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    style={styles.privacyText}
                  >
                    Privacy Policy
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Copyright */}
        <div style={styles.bottomSection}>
          <div style={styles.copyright}>
            2023 SiriDharini. All rights reserved. Crafted by Brainydarts Technology
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;